angular.module('app').config(providersRouting);

function providersRouting($routeProvider) {
  $routeProvider
    .when('/providers', {
      pageTitle: 'PROVIDERS',
      template: '<providers-page></providers-page>',
      menu: 'contacts',
      accessPermission: 'index_provider_accountadmin',
      authReq: true,
    })
    .when('/providers/new', {
      pageTitle: 'ADD_PROVIDER',
      template: '<provider-page></provider-page>',
      breadcrumb: {
        label: 'PROVIDERS',
        parent: 'providers',
        ajs: true,
      },
      menu: 'contacts',
      accessPermission: 'create_provider_accountadmin',
      authReq: true,
    })
    .when('/providers/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'EDIT_PROVIDER',
      template: '<provider-page></provider-page>',
      breadcrumb: {
        label: 'PROVIDERS',
        parent: 'providers',
        ajs: true,
      },
      menu: 'contacts',
      accessPermission: 'show_provider_accountadmin',
      authReq: true,
    });
}

providersRouting.$inject = ['$routeProvider'];
